export default (urlObject, parameters = {}) => Object.keys(parameters)
  .reduce(
    (url, parameterName) => url.replace(new RegExp(`\\/:${parameterName}\\??`), `/${parameters[parameterName]}`),
    urlObject._baseUrl,
  );
